var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25636",
    transform: "translate(-319.5 -138.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 11",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(320 139)",
    style: {
      stroke: "#e0e0e0",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon/PDF/36pt"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25637"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13616",
    d: "M290.172 13a2 2 0 0 1 1.414.586l7.828 7.828a2 2 0 0 1 .586 1.414V40a3.009 3.009 0 0 1-3 3h-18.015A3 3 0 0 1 276 40V16a3.009 3.009 0 0 1 3-3zm.828 1.75v5.75a1.5 1.5 0 0 0 1.5 1.5h5.75z",
    transform: "translate(60 139)",
    style: {
      fill: "#2b579a",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13617",
    d: "m283.652 36-1.936-10.432h2.416l.72 4.88q.1.816.208 1.648.113.816.208 1.648h.064q.16-.832.3-1.648l.32-1.648 1.12-4.88h2l1.12 4.88q.16.8.3 1.632.16.816.32 1.664h.064q.113-.848.208-1.664l.224-1.632.72-4.88h2.256L292.436 36h-2.96l-1.024-4.736q-.127-.608-.24-1.216-.1-.624-.176-1.2h-.064l-.208 1.2q-.1.608-.224 1.216L286.564 36z",
    transform: "translate(60 139)",
    style: {
      fill: "#fff"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocNormal);
export default __webpack_public_path__ + "static/media/doc-normal.4accd628bbf3c2ba05cc70827cfd7b3a.svg";
export { ForwardRef as ReactComponent };